export default "__VITE_ASSET__5Jw91DDY__"